<template>
	<div>
		<div class="row">
			<div class="col-8 mb-4">
				<h1 class="float-left" v-if="isNew && !outcomeGroup.id">{{ $t("add-learning-outcomes-group") }}</h1>
				<h1 class="float-left" v-else-if="loaded">
					{{ outcomeGroup.title }}
				</h1>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
			<div class="col-4 mb-4" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
				<button class="btn btn-primary float-right ml-4" @click="finishEditing" v-if="editing" :disabled="!outcomeGroup.title">
					{{ $t("save") }}
				</button>
				<button class="btn btn-primary float-right" @click="startEditing" v-else>
					{{ $t("edit") }}
				</button>
				<button class="btn btn-outline-danger float-right" @click="$router.go()" v-if="editing && outcomeGroup.id">{{ $t("cancel") }}</button>
			</div>
		</div>


		<div class="row" v-if="error">
			<div class="col-12">
				<b-alert variant="danger" show>{{ error }}</b-alert>
			</div>
		</div>

		<div class="row">
			<div class="col-12 mb-2">
				<label class="font-bold">{{ $t("title") }}</label>
				<input
					type="text"
					class="form-control"
					value=""
					:placeholder="$t('enter-title')"
					v-model="outcomeGroup.title"
					v-if="editing"
				/>
				<p class="mb-0" v-else-if="loaded">
					{{ outcomeGroup.title }}
				</p>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>

            <div class="col-12 mb-2">
				<label class="font-bold">{{ $t("notes") }}</label>
				<textarea-autosize
					type="text"
					class="form-control"
					value=""
					:placeholder="$t('enter-notes')"
					v-model="outcomeGroup.note"
					v-if="editing"
				></textarea-autosize>
				<p class="mb-0" v-else-if="loaded">
					{{ outcomeGroup.note }}
				</p>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>


			<div class="col-12 mb-4" v-if="outcomeGroup.id">
				<div class="clearfix mb-2">
					<button type="button"
                        class="btn float-right"
                        :class="{'btn-primary': onlyunmapped, 'btn-outline-secondary': !onlyunmapped}"
                        @click="toggleUnMapped()">
                            {{ $t('unmapped-learning-outcomes') }}
                    </button>
                    <SelectInput
                        v-model="curriculum"
                        @input="value => refresh({ root_id: value ? value.id : '' })"
                        :label="$t('curriculum')"
                        :options="curricula"
                        optionLabel="title"
                        :srOnly="true"
                        :nullable="true"
                        :nullLabel="$t('curricula')"
                        class="mr-2 float-right"
                    />
                    <SearchBar 
                        v-model="filters.search" 
                        :placeholder="$t('search')"
                        @input="value => refresh({ search: value })" 
                        class="float-right mr-2"
                    />
					<h2>{{ $t("learning-outcomes") }}</h2>
				</div>
                <div class="clearfix mt-1 mb-2" v-if="learningoutcomesCount && $UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                    <button
                        class="float-right btn btn-secondary"
                        @click="addNewLearningOutcome"
                        v-if="loaded"
                        :disabled="isNewOutcome"
                    >
                        <b-icon icon="plus" />
                        {{ $t("add") }}
                    </button>
                </div>

				<div v-if="loaded && learningoutcomes.length > 0" class="list-group">
					<div class="list-group-item d-none d-sm-inline">
						<div class="row">
							<div class="col-12 col-sm-4 font-bold">{{ $t("name") }}</div>
                            <!--div class="col-12 col-sm-6 font-bold">{{ $t("notes") }}</div-->
						</div>
					</div>
					<div class="list-group-item" v-for="(outcome,key) in learningoutcomes" :key="key" @click="selectOutcome(outcome.id)" @contextmenu.prevent="deletingOutcome = outcome.id">
						<div class="row" v-if="editingOutcome[outcome.id]">
							<div class="col-12 mb-1">
								<b-form-input v-model="outcome.title" :placeholder="$t('enter-name')"></b-form-input>
							</div>
                            <div class="col-12 mb-1">
								<b-form-input v-model="outcome.code" :placeholder="$t('enter-code')"></b-form-input>
							</div>
                            <div class="col-12 mb-1">
								<textarea-autosize v-model="outcome.note" :placeholder="$t('enter-notes')" class="form-control"></textarea-autosize>
                            </div>
                            <div class="col-12 mb-1 text-right">
                                <button class="btn btn-primary mb-1" @click="saveOutcome(outcome)" :disabled="!outcome.title">{{ $t('save') }}</button>
                                <button class="btn btn-danger mb-1 ml-1" @click="deleteOutcome(outcome.id)" v-if="outcome.id">{{ $t('delete') }}</button>
                            </div>
						</div>
						<div v-else>
                            <button class="btn btn-danger mb-1 ml-1 float-right" @click.prevent="deleteOutcome(outcome.id)" v-if="deletingOutcome == outcome.id">{{ $t('delete') }}</button>
							<p class="mb-0">
								<template v-if="outcome.code">{{ outcome.code }}: </template>
								{{ outcome.title }}
							</p>
							<p class="mb-0"> {{ outcome.note ? outcome.note : $t('no-notes') }} </p>
						</div>
					</div>
				</div>

				<div class="card text-center" v-else-if="loaded">
					<div class="card-body">
						<p class="mb-0">{{ $t('none') }}</p>
					</div>
				</div>

				<table v-else class="table">
					<tr v-for="item in Array(5)" v-bind:key="item">
						<td>
							<div class="skeleton midnight h16 w-half"></div>
						</td>
						<!--td>
							<div class="skeleton midnight h16 w-half"></div>
						</td-->
					</tr>
				</table>
                <div class="clearfix mt-4" v-if="!learningoutcomesCount">
					<button
						class="float-right btn btn-secondary"
						@click="addNewLearningOutcome"
						v-if="loaded"
                        :disabled="isNewOutcome"
					>
						<b-icon icon="plus" />
						{{ $t("add") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SearchBar from "src/components/Table/SearchBar.vue"

export default {
	components: {
        SearchBar
	},
	data: function () {
		return {
			//success: false,
			onlyunmapped: false,
			error: null,
			loaded: false,
			editing: false,
            outcomeGroup: {},
            learningoutcomes: [],
			editingOutcome:{},
			deletingOutcome: null,
            isNewOutcome : false,
            lo_threshold:5,
            curriculum: null,
            curricula:[],
            filters:{
                root_id: null
            }
		};
	},
	mounted() {
        this.listCurricula()
		if (this.isNew) {
			this.loaded = true;
			this.startEditing();
		} else {
			this.editing = false;
            this.listOutcomesByGroupId();
			this.getOutcomeGroupById(this.$route.params["group_id"]);
		}
	},
	methods: {
		selectOutcome(id) {
            //if(!this.$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')) return;
			if(id){
				this.$router.push(`/curriculum-mapping/learning-outcomes/edit/${id}`);
			}
		},
        getOutcomeGroupById(id) {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/get`,{
                method: "post",
                data: {
                    id: id
                }
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.outcomeGroup = res.result;
                    this.loaded = true;
				} else {
					console.log(res.status)
				}
			}).catch(error => {
					this.$log.error.call(this, error);
				});
        },
        listOutcomesByGroupId() {
            if(this.$route.params['group_id']){
                this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`,{
                method: "post",
                data: {
                    group_id: this.$route.params['group_id'],
                    unmapped: this.onlyunmapped,
                    ...this.filters
                }
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.learningoutcomes = res.results;

				} else {
					console.log(res.status);
				}
			}).catch(error => {
					this.$log.error.call(this, error);
				});
            }

        },
		startEditing() {
			this.editing = true;
		},
		finishEditing: function () {
            this.$store.commit("showBlockingSpinner");
			this.saveOutcomeGroup();

		},
        saveOutcomeGroup() {
			this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/save`, {
				method: "post",
				data: this.outcomeGroup
			})
			.then((res) => {
				if (res.status === "SUCCESS") {
                    //console.log(res.result);

					this.error = null;
					//this.success = true;
					this.editing = false;
                    this.loaded = true;

                    this.outcomeGroup = res.result;

                    this.$store.commit("hideBlockingSpinner");
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "There was a problem saving the learning outcome group.";
					}
				}
			})
			.catch((error) => {
			this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.error = "There was a problem saving the learning outcome group.";
			});
        },
        deleteOutcome(id){
            this.$store.commit("showBlockingSpinner");
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/delete`, {
                    method: "post",
                    data: {
                        id: id
                    }
                    })
                    .then((res) => {
                        if (res.status === "SUCCESS") {

                            const deletionIndex = this.learningoutcomes.findIndex(outcome => outcome.id === id);
                            if (deletionIndex !== -1){ //check that the entry was found
                                this.learningoutcomes.splice(deletionIndex,1);
                            }

                            this.$store.commit("hideBlockingSpinner");
                        } else {
                            if (res.error_message) {
                                this.error = res.error_message;
                            } else {
                                this.error = "There was a problem deleting the learning outcome";
                            }
                        }
                    })
                    .catch((error) => {
                    this.$store.commit("hideBlockingSpinner");
                        this.$log.error.call(this, error);
                        this.error = "There was a problem deleting the learning outcome .";
                });
        },
		saveOutcome(outcome){
            this.$store.commit("showBlockingSpinner");
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/save`, {
                method: "post",
                data: outcome
                })
                .then((res) => {
                    if (res.status === "SUCCESS") {
                        //console.log(res.result);
                        if (outcome.id === ''){
                            //Checks if the input is a new outcome, if so, we search for it using its title
                            const matchingOutcome = this.learningoutcomes.find(item => item.title === outcome.title)

                            //If found, we take the ID assigned by the API response and assign it to learningoutcomes
                            if (matchingOutcome) {
                                matchingOutcome.id = res.result.id;
                                this.$set(this.editingOutcome,matchingOutcome.id, false);
                                delete this.editingOutcome[''];
                            }
                        }
                        this.editingOutcome[outcome.id] = false;
                        this.isNewOutcome=false;
                        this.$store.commit("hideBlockingSpinner");
                    } else {
                        if (res.error_message) {
                            this.error = res.error_message;
                        } else {
                            this.error = "There was a problem saving the learning outcome";
                        }
                    }
                })
                .catch((error) => {

                    this.$log.error.call(this, error);
                    this.error = "There was a problem saving the learning outcome .";
            });
        },
		addNewLearningOutcome () {
            const newLO ={
                id: '',
                learningoutcomegroup_id: this.outcomeGroup.id,
                title: '',
                note: '',
                code:''
            };

			if(this.learningoutcomesCount){
                this.learningoutcomes.unshift(newLO)
            } else {
                this.learningoutcomes.push(newLO);
            }

            this.$set(this.editingOutcome,'',true)
            this.isNewOutcome = true;
		},
		toggleUnMapped(){
			this.onlyunmapped = !this.onlyunmapped
			this.listOutcomesByGroupId();
		},
        listCurricula() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`,{
                method: "post"
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    /*let root_ids = new Set();

                    this.learningoutcomes.forEach(x => {
                        x.curriculummap.forEach(y =>{
                            if(!root_ids.has(y.root_id) && y.root_id !== null){
                                root_ids.add(y.root_id)
                            }
                        })
                    })
                    this.curricula = res.results.filter( x => Array.from(root_ids).includes(x.id)  )*/
                    this.curricula = res.results
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
            this.listOutcomesByGroupId()
        }
	},
	computed: {
		isNew: function () {
			return !this.$route.params["group_id"];
		},
        learningoutcomesCount(){
            if(this.learningoutcomes.length>0){
                 return this.learningoutcomes.length >=this.lo_threshold;
            }
            return '';
        }
	},
};
</script>


